import React, { useState, useEffect } from 'react';
import InstituteDashboard from './InstituteDashboard';

const DelScholarshipsIns = () => {
    const [Scholarships, setScholarships] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedScholarships();
    }, []);

    const fetchDeletedScholarships = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/scholarships/deleted');
            const data = await response.json();
            setScholarships(data);
        } catch (error) {
            console.error('Error fetching deleted Scholarships:', error);
        }
    };

    const handleRestore = async (ScholarshipsId) => {
        try {
            const response = await fetch(`https://api.myskills.lk/scholarships/restore/${ScholarshipsId}`, {
                method: 'POST'
            });
            if (response.ok) {
                setScholarships(Scholarships.filter(Scholarships => Scholarships.id !== ScholarshipsId));
                window.alert('Scholarship Restored');
            } else {
                console.error('Failed to restore Scholarship');
            }
        } catch (error) {
            console.error('Error restoring Scholarship:', error);
        }
    };

    const handlePermanentDelete = async (ScholarshipsId) => {
        try {
            const response = await fetch(`https://api.myskills.lk/scholarships/delete/permanent/${ScholarshipsId}`, {
                method: 'DELETE'
            });
            if (response.ok) {
                setScholarships(Scholarships.filter(Scholarships => Scholarships.id !== ScholarshipsId));
                window.alert('Scholarship delete permanently');
            } else {
                console.error('Failed to delete Scholarship permanently');
            }
        } catch (error) {
            console.error('Error deleting Scholarship permanently:', error);
        }
    };


    return (
        <div>
            <InstituteDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE SCHOLARSHIPS</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            placeholder="Search by Programme, Country, or University"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH"/>
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                            <tr>
                                <th>Scholarship Programme Name</th>
                                <th>Country</th>
                                <th>Offered By</th>
                                <th>Closing Date</th>
                                <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {Scholarships
                                .filter((srach) =>
                                    srach.sProgrammeName.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((Scholarships) => (
                                    <tr key={Scholarships.id}>
                                        <td>{Scholarships.sProgrammeName}</td>
                                        <td>{Scholarships.country}</td>              
                                        <td>{Scholarships.university}</td>
                                        <td>{new Date(Scholarships.closingDate).toLocaleDateString('en-CA')}</td>
                                        <td>{Scholarships.institutePhone}</td>
                                        <td>{Scholarships.instituteEmail}</td>
                                        <td>
                                            <a href={Scholarships.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(Scholarships.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(Scholarships.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default DelScholarshipsIns;
